import restClient from '@/services/clients/rest'
import { createRestCrudService } from '@/services/GenericCrudService'

const resourceName = 'Cost Code'
const resourcePath = 'costing/codes'
const crudService = createRestCrudService(resourceName, resourcePath)

export default Object.assign(crudService, {
  async bulkImport (items, options) {
    try {
      const response = await restClient.post(`${resourcePath}/bulk-import`, {
        items,
        options
      })
      return response.data
    } catch (error) {
      console.warn(`Error submitting cost code bulk import`, error, items, options)
      throw error
    }
  }
})
